import React, { Component } from "react";

class Loader extends Component {
  render() {
    return (
      <div class="loader-bg">
        <div class="loader-track">
          <div class="loader-fill"></div>
        </div>
      </div>
    );
  }
}

export default Loader;
